import React, { useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import ModalContext from './Context/modal';
import AnimationContext from './Context/animation';

const AppRouter = () => {
  const [modalData, setModalData] = useState(null);
  const [showMediaModal, setShowMediaModal] = useState(false);

  const [isAnimating, setIsAnimating] = useState(false);
  const [isTutorial, setIsTutorial] = useState(true);

  // Imperative escape hatch: useHotspotFilter.js registers a "settle" function
  // here so sibling nav/filter components can force a mid-animation state to
  // rest (and apply their own click) instead of getting silently ignored
  // while isAnimating is true.
  const settleRef = useRef(null);

  const slug = document.querySelector('#root').getAttribute('data-slug');

  return (
    <AnimationContext.Provider
      value={{
        isAnimating,
        setIsAnimating,
        isTutorial,
        setIsTutorial,
        settleRef,
      }}
    >
      <ModalContext.Provider
        value={{
          modalData,
          setModalData,
          showMediaModal,
          setShowMediaModal,
        }}
      >
        <Router>
          <Routes>
            <Route path={`/interactives/${slug}/app/:year/:month`} element={<App />} />
            <Route path={`/interactives/${slug}/app/:year`} element={<App />} />
            <Route path={`/interactives/${slug}/app`} element={<App />} />
          </Routes>
        </Router>
      </ModalContext.Provider>
    </AnimationContext.Provider>
  );
};

export default AppRouter;
